module.exports = __webpack_public_path__ + "img/fruitsmurs.554b787a.png";